import { render, staticRenderFns } from "./AnswerPanel.vue?vue&type=template&id=45602928&scoped=true&"
import script from "./AnswerPanel.vue?vue&type=script&lang=js&"
export * from "./AnswerPanel.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPanel.vue?vue&type=style&index=0&id=45602928&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45602928",
  null
  
)

export default component.exports